/**
 * Payment gateway return URLs may use checkoutId, checkout_id, or checkout (e.g. Paymennt).
 */
export function getCheckoutIdFromSearchParams(searchParams) {
  if (!searchParams) return null;
  return (
    searchParams.get('checkoutId') ||
    searchParams.get('checkout_id') ||
    searchParams.get('checkout') ||
    null
  );
}

export const PAYMENNT_CHECKOUT_ID_KEY = 'paymennt_checkout_id';
export const PAYMENNT_CHECKOUT_PENDING_KEY = 'paymennt_checkout_pending';

/**
 * Checkout id from URL (return / failure flows) or session only after Pay Now (pending redirect).
 * Avoids polling /payment/status with a stale id left in sessionStorage from an old session.
 */
export function getPendingCheckoutId(searchParams) {
  const fromUrl = getCheckoutIdFromSearchParams(searchParams);
  if (fromUrl) return fromUrl.trim() || null;
  if (typeof sessionStorage === 'undefined') return null;
  if (sessionStorage.getItem(PAYMENNT_CHECKOUT_PENDING_KEY) !== '1') return null;
  const id = sessionStorage.getItem(PAYMENNT_CHECKOUT_ID_KEY);
  return id && String(id).trim() ? String(id).trim() : null;
}

export function setPaymenntCheckoutSession(checkoutId) {
  if (!checkoutId || typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(PAYMENNT_CHECKOUT_ID_KEY, String(checkoutId));
  sessionStorage.setItem(PAYMENNT_CHECKOUT_PENDING_KEY, '1');
}

export function clearPaymenntCheckoutSession() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(PAYMENNT_CHECKOUT_ID_KEY);
  sessionStorage.removeItem(PAYMENNT_CHECKOUT_PENDING_KEY);
}

/** Remove payment-return query keys so a bad id is not re-read on reload. */
export function stripCheckoutQueryParams(searchString) {
  const p = new URLSearchParams(searchString || '');
  p.delete('checkout');
  p.delete('checkout_id');
  p.delete('checkoutId');
  const q = p.toString();
  return q ? `?${q}` : '';
}
